import axios from "axios";
import { getCRMSettings } from "../crmSettingsAdapter";

const CRM_API_BASE_URL = "https://staging-api.senseicrm.com";
const INTEL_API_BASE_URL = "https://d3l31sav1z1w9g.cloudfront.net/api/v1/provider/";

const apiClient = axios.create();
const crmApi = axios.create({
	headers: {
		Accept: "application/json"
	}
});

export const postToUrl = (url, data, config) => apiClient.post(url, data, config);
export const postApiUrl = (apiUrl, apiData, config = undefined) => postToUrl(apiUrl, apiData, config);

crmApi.interceptors.request.use((config) => {
	const baseUrl = CRM_API_BASE_URL; //const_var?.crmSetting?.api_post_url;
	if (!baseUrl) {
		console.error("base url is not defined");
		return config;
	}
	config.baseURL = `${baseUrl}/api`;
	return config;
});
crmApi.interceptors.response.use(
	(res) => res.data,
	(err) => Promise.reject(err.response?.data || err)
);

export const setAuthHeader = (token) => {
	if (token) {
		crmApi.defaults.headers.Authorization = `Bearer ${token}`;
	}
};

export function setApiTokenHeader() {
	crmApi.defaults.headers["X-API-Token"] = getCRMSettings()["api-key"];
}

export default crmApi;


export const intelApi = axios.create({
	baseURL: INTEL_API_BASE_URL,
	headers: {
		Accept: "application/json",
		"Content-Type": "application/json"
	}
});

intelApi.interceptors.request.use((config) => {
	config.headers["api-key"] = "sk-provider-2f8a9c3e7d1b4x6m0p5q8r";
	return config;
},
	(error) => Promise.reject(error)
);

intelApi.interceptors.response.use(
	(response) => response.data,
	(error) => {
		const message = error.response?.data?.message || "Something went wrong";
		return Promise.reject(message);
	}
);
